module.exports = __webpack_public_path__ + "1c0b4eb93fcf561eec03297a24922d6c.ttf";


//////////////////
// WEBPACK FOOTER
// ./node_modules/open-sans-fontface/fonts/SemiboldItalic/OpenSans-SemiboldItalic.ttf?v=1.1.0
// module id = 1000
// module chunks = 0